import { takeEvery, select, put } from 'redux-saga/effects'
import { normalizeFeature } from 'schemas/feature'
import { SET_FEATURE_SNAPSHOT } from 'actions/feature/snapshots'
import {
  setFeatureAsCurrentFeature,
  setSnapshotAsCurrentFeature,
} from 'actions/feature/features'
import { CURRENT_URI } from 'constants/featureSnapshots'
import { getRawSnapshotFeature } from 'selectors/feature/snapshots'

export function* watchSetSnapshot() {
  yield takeEvery(SET_FEATURE_SNAPSHOT, setFeatureSnapshot)
}

function* setFeatureSnapshot(payload) {
  const { uri } = payload

  if (uri === CURRENT_URI) {
    yield put(setFeatureAsCurrentFeature())
  } else if (uri) {
    const { feature } = yield select(getRawSnapshotFeature, { uri })
    const snapshotFeature = normalizeFeature(feature)

    yield put(setSnapshotAsCurrentFeature(snapshotFeature))
  }
}
